import { render, staticRenderFns } from "./GridRecord.vue?vue&type=template&id=6b4f4a7c&scoped=true&name=GridRecord"
import script from "./GridRecord.vue?vue&type=script&lang=js"
export * from "./GridRecord.vue?vue&type=script&lang=js"
import style0 from "./GridRecord.vue?vue&type=style&index=0&id=6b4f4a7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4f4a7c",
  null
  
)

export default component.exports